// extracted by mini-css-extract-plugin
export default {"second_section":"AboutPage_second_section__kOeLb","item_holder":"AboutPage_item_holder__hEidq","item":"AboutPage_item__5YhLQ"};